export default {
  DEBUG: false,
  QRS: {
    GatewayURL:
      'http://devqrsdb01.corp.archcapservices.com:8080/ArchReGwt/hello?user=aw&startPageName=viewLocationRates&introducerIdentifier=',
    PowerBIReportsUrl:
      'https://app.powerbi.com/groups/91c13d2f-ea27-4efc-a9c5-119bdd713568/list?ctid=441d4a8f-7999-4d6a-9670-672cf8d03e35&experience=power-bi',
  },
  //This flag is used to determine if policy renew operation to be done from FE side or server side. False value does the renew operation in FE side. True does in Server side. TODO:// Remove/change to true once BE is ready
  POLICY: {
    renewalFromServer: true,
    isPolicyReferenceNumberFeatureOn: true,
    certAndNotificationFromTransaction: true,
  },
  PROGRAM: {
    isPricingFeatureOn: true,
    isARFGenerated: true,
  },
  WORKFLOW: {
    isIRFeatureOn: true,
  },
  LOCATION: {
    locationUrl: 'https://vinta-np.archre.com/locations',
    auTemplatesUrl: 'https://vinta-np.archre.com/documents/auTemplates',
    uwTemplatesUrl: 'https://vinta-np.archre.com/documents/uwTemplates',
  },
  VINTA: {
    BASE_URL: 'https://vinta-np.archre.com',
  },
  FILER_MAILBOX_ADDRESS: 'HybridAttach_Filer_Dev@archgroup.com',
  AUTHENTICATION: {
    MODE: 'AUTH0',
    DOMAIN: 'archre-nonprod.us.auth0.com',
    CLIENT_ID: 'AqXIc9x472nuvNPMmu7Nqr2OVjKLMbB9',
    CALLBACK_URL: `https://${window.location.host}/callback`,
    AUDIENCE: 'https://archway-dev.archre.com/api',
    LOGOUT_URL: `https://${window.location.host}/`,
  },
};
